import React, { useEffect, useMemo, useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [currentSlide, setCurrentSlide] = useState(0);

  const offerImages = useMemo(
    () => ['/media/work_1.jpeg', '/media/work_2.jpeg', '/media/work_3.jpeg'],
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % offerImages.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [offerImages.length]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = 'Feedback Form Submission';
    const body = `Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0AMessage: ${formData.message}`;
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=primelawnsnowmanagement@gmail.com&su=${subject}&body=${body}`, '_blank');
    setFormData({ name: '', email: '', message: '' });
  };

  const showPreviousSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + offerImages.length) % offerImages.length);
  };

  const showNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % offerImages.length);
  };

  return (
    <section className="py-4 md:py-4">
      <h1 className="dest_heading">Our Offers</h1>

      <section className="text-gray-600 body-font relative mx-auto w-full max-w-7xl px-4 sm:px-6 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="py-8 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <div className="md:col-span-1 overflow-hidden rounded-lg bg-gray-300 shadow-lg">
              <div className="relative">
                <img
                  src={offerImages[currentSlide]}
                  alt="Our offers"
                  className="h-[480px] w-full object-cover"
                />

                <button
                  type="button"
                  onClick={showPreviousSlide}
                  className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-xl text-gray-700 shadow-md transition hover:bg-white"
                  aria-label="Previous offer"
                >
                  ←
                </button>
                <button
                  type="button"
                  onClick={showNextSlide}
                  className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-xl text-gray-700 shadow-md transition hover:bg-white"
                  aria-label="Next offer"
                >
                  →
                </button>

                <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-2">
                  {offerImages.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => setCurrentSlide(index)}
                      aria-label={`Go to slide ${index + 1}`}
                      className={`h-2.5 w-2.5 rounded-full ${
                        currentSlide === index ? 'bg-white' : 'bg-white/50'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="md:col-span-1 bg-white flex flex-col md:ml-auto w-full md:py-8 md:mt-0">
              <h2 className="font-semibold font-800 text-2xl text-black mb-2">Feedback</h2>
              <p className="leading-relaxed mb-5 text-gray-600">Please give your priceless review</p>

              <form onSubmit={handleSubmit}>
                <div className="relative mb-4">
                  <label htmlFor="name" className="leading-7 text-sm text-gray-600">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input w-full bg-white text-base outline-none text-gray-700 py-3 px-4 leading-8"
                    required
                  />
                </div>

                <div className="relative mb-4">
                  <label htmlFor="email" className="leading-7 text-sm text-gray-600">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input w-full bg-white text-base outline-none text-gray-700 py-3 px-4 leading-8"
                    required
                  />
                </div>

                <div className="relative mb-4">
                  <label htmlFor="message" className="leading-7 text-sm text-gray-600">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-input w-full bg-white h-32 text-base outline-none text-gray-700 py-3 px-4 resize-none leading-6"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn-primary text-white border-0 py-3 px-8 focus:outline-none rounded-lg text-lg font-semibold"
                >
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ContactForm;